import { AxiosResponse } from 'axios';
import { OtpFormValue } from 'components/OtpModal/OtpModal.config';
import { FormikHelpers } from 'formik';
import { otpCodeFieldName } from 'pages/profile/profile.config';
import { useDispatch, useStore } from 'react-redux';
import apiRequest from 'services/api/api.config';
import { unprocessableEntity_422 } from 'services/api/api.statusCodes';
import {
  resetOtpStateAction,
  setOtpStateAction,
} from 'services/otp/otp.actions';
import { makeSelectPostContractOtpCheckApiConfig } from 'services/otp/otp.selectors';
import { ValuesContactType } from './OtpContractModal.types';

export function useCreateHandleContractOtpCheckSubmit(
  valuesContact: ValuesContactType,
  onSuccess: () => void,
  onIncorrectOtpSubmitError?: () => void,
) {
  const reduxStore = useStore();
  const dispatch = useDispatch();

  return async (values: OtpFormValue, actions: FormikHelpers<OtpFormValue>) => {
    try {
      const apiConfig = makeSelectPostContractOtpCheckApiConfig({
        otp: values[otpCodeFieldName],
        phonePrefix: valuesContact.phonePrefix,
        phoneNumber: valuesContact.phoneNumber,
      })(reduxStore.getState());

      await apiRequest.request(apiConfig.requestConfig);

      actions.resetForm();

      dispatch(resetOtpStateAction());

      onSuccess();
    } catch (fetchError) {
      if (fetchError.response?.data) {
        const errorResponse = fetchError.response as AxiosResponse;

        if (errorResponse?.status === unprocessableEntity_422) {
          actions.resetForm();
          dispatch(
            setOtpStateAction({
              hasError: true,
              hintText: '',
              errorInfos: errorResponse.data.error.errorInfos,
              counterCheck: errorResponse.data.counterCheck ?? 4,
            }),
          );
        }

        onIncorrectOtpSubmitError?.();
      }
    }
  };
}
